import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import formatOptions from '@/utils/format-edit/createFormatOptions.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateFormatDialog',
  setup(__props, { expose }) {

const visible = ref(false)

function openDialog() {
  visible.value = true
}

function closeDialog() {
  visible.value = false
}

function onVisibleInput(value: boolean) {
  visible.value = value
}

expose({ openDialog })

return { __sfc: true,visible, openDialog, closeDialog, onVisibleInput, formatOptions }
}

})